// withProvider.js
import React from 'react';
import { CacheProvider } from '@emotion/react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import createCache from '@emotion/cache';

import theme from './gatsby-theme-material-ui-top-layout/theme';
import createStore from './state/createStore';
import { setStore } from './utils/api';
import { AlertBar } from './components/custom';
import MaintenanceGate from './components/custom/MaintenanceGate';
import '@fontsource/rubik';
import '@fontsource/rubik/500.css';
import '@fontsource/rubik/600.css';
import '@fontsource/rubik/700.css';

const clientSideEmotionCache = createCache({ key: 'css', prepend: true });

const { store, persistor } = createStore();
setStore(store);

export default function wrapWithProvider({ element }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CacheProvider value={clientSideEmotionCache}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <div>
                <AlertBar />
                <MaintenanceGate>{element}</MaintenanceGate>
              </div>
            </LocalizationProvider>
          </ThemeProvider>
        </CacheProvider>
      </PersistGate>
    </Provider>
  );
}
